import React from 'react'
import { profileSelector } from '../reducers/profile'

import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

function StagingDebugBlock({ profile }) {
  if (process.env.REACT_APP_API_URL.indexOf('staging') === -1) {
    return null
  }
  return (
    <div>
      <a
        style={{ color: 'red' }}
        href={`https://admin-radio-staging.arzamas.academy/api/v1/debug_move_all_subscriptions?from=${profile.id}&to=483040`}
        target="_blank">
        Сбросить подписки (они перенесутся на другой аккаунт)
      </a>
      <br />
      <a href={`https://admin-radio-staging.arzamas.academy/admin/accounts/${profile.id}/edit`} target="_blank">
        Открыть аккаунт в админке
      </a>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector
})
export default connect(mapStateToProps)(StagingDebugBlock)
